import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseToast() {
  const [visible, setVisible] = useState<boolean>(false);
  useEffect(() => {
    const showTimer = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(showTimer);
  }, []);
  return <AnimatePresence data-id="element-219" data-mp="2quq2odo2htwa">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} role="status" aria-live="polite" className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-sm rounded-2xl border border-line bg-raised p-4 shadow-2xl sm:left-4 sm:right-auto" data-id="element-220" data-mp="2qvhv5fmdbbic">
          <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="absolute right-3 top-3 text-neutral-600 transition-colors hover:text-neutral-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-221" data-mp="f7ia2f30r0ql">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="23765brui7ehj" />
          </button>
          <p className="flex items-center gap-1.5 text-[10px] font-extrabold uppercase tracking-[0.15em] text-gold" data-id="element-223" data-mp="23534sdvq62yk">
            <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-224" data-mp="1bg01b0bnwwmz" />
            Compra verificada
          </p>
          <p className="mt-2 pr-6 text-sm text-neutral-200" data-id="element-225" data-mp="1fh3gdklvyon5">
            <span className="font-bold text-white" data-id="element-226" data-mp="1ffiltuzkn5pa">Gonzalo M.</span> de Rosario
            compró Megakit + Programación Personalizada 🏋️
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}